class LogoScroller extends HTMLElement {
  constructor() {
    super();

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0
    }

    this.observer = new IntersectionObserver((entry) => {
      if (entry[0].isIntersecting) {
        this.classList.add('in-view');
      } else {
        this.classList.remove('in-view');
      }
    }, options)
    this.observer.observe(this);
  }
}


customElements.define('logo-scroller', LogoScroller);